function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.46 283.46"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M248.03 198.424c0-28.86-21.677-52.753-49.605-56.252V28.347h35.433V0H49.606v28.347h35.433v113.825c-27.927 3.499-49.606 27.391-49.606 56.252v28.348h92.126v56.693h28.34v-56.693h92.132v-28.348zM170.08 28.347v113.385h-56.695V28.347h56.695zM63.779 198.426v-.002c0-15.63 12.717-28.344 28.347-28.344h7.086v-.002h85.04v.002h7.086c15.63 0 28.347 12.714 28.347 28.344l-155.906.002z",
  id: "GRID_GUIDES"
})));